import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const StarredContactsZeroState6Icon = (props: IconProps) => (
  <Icon height="32px" width="32x" viewBox="0 0 32 32" {...props}>
    <rect width="32" height="32" fill="#E5F2FF" rx="16" />
    <mask id="a" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse">
      <circle cx="16" cy="16" r="16" fill="#B94C24" />
    </mask>
    <g mask="url(#a)">
      <path fill="#16C0E6" d="M-5.12-6.08h63.36V54.4H-5.12z" />
      <path
        fill="#fff"
        d="M18.121 7.86c0 3.104-2.422 5.62-5.41 5.62-2.986 0-5.41-2.516-5.41-5.62 0-3.103 2.423-5.62 5.41-5.62 2.989 0 5.41 2.516 5.41 5.62Z"
      />
      <path
        fill="#F7A283"
        d="M14.178 14.924s-1.026.882-2.638 0l.232-2.842h2.174l.232 2.842Z"
      />
      <path
        fill="#F7A283"
        d="M15.303 8.959c0-1.355-1.094-2.608-2.444-2.608-1.35 0-2.444 1.253-2.444 2.608 0 0-.056 1.744-.056 1.827 0 1.288 1.525 2.905 2.5 2.905 1.126 0 2.51-1.958 2.51-2.934 0-.083-.066-1.798-.066-1.798Z"
      />
      <path
        fill="#323232"
        d="M10.374 10.292s.604 1.751 1.007 1.872c.403.12.623-.505 1.479-.494.856.011.939.514 1.422.478.483-.035 1.075-1.766 1.075-1.766s.062.92-.091 1.42c-.118.383-.341 1.068-.634 1.341-.37.347-1.26.979-1.766.992-.498.013-1.428-.634-1.786-.98-.284-.274-.51-.996-.624-1.374-.166-.548-.082-1.489-.082-1.489Z"
      />
      <path
        fill="#fff"
        d="m9.975 9.548 5.393-5.676-3.988-.332-2.988 2.717 1.583 3.29Z"
      />
      <path
        fill="#fff"
        d="m13.059 5.2 3.213 1.66-.463 2.951-3.673-4.308.923-.303Z"
      />
      <path
        fill="#F7A283"
        d="M12.882 16.21c1.3 0 1.933-1.266 1.629-1.357-.86-.255-1.498-.41-1.498-.41s-.728.164-1.711.464c-.338.102.317 1.303 1.58 1.303Z"
      />
      <path
        fill="#FFEC99"
        d="M20.744 20.988c-.388-1.164-1.108-3.189-1.962-4.226-.514-.624-2.989-1.545-4.338-1.997-.262 1.24-2.892 1.241-3.19.053-1.19.426-3.568 1.36-4.375 2.05-1.807 1.546-2.308 5.362-2.414 5.909-.327 1.687-.939 5.244-.464 6.114.27.493.62 1.11 1.647 1.625l.642.129v.82h14.724c.45-.35.793-1.664.798-2.574.008-1.764-.446-6.035-1.068-7.903Z"
      />
      <path
        fill="#F7A283"
        d="M27.203 17.96s-1.04.895-2.674 0l.235-2.879h2.204l.235 2.88Z"
      />
      <path
        fill="#fff"
        d="M23.041 12.84s-.334-1.853.26-2.998c.745-1.44 2.98-2.19 4.69-.702 1.098.955.566 3.883.566 3.883l-3.741-1.59-1.775 1.407Z"
      />
      <path
        fill="#F7A283"
        d="M23.51 12.256s-.316-.204-.56.122c-.245.326-.082 1.55.53 1.55s.03-1.672.03-1.672ZM28.24 12.256s.317-.204.561.122c.245.326.082 1.55-.53 1.55-.611 0-.03-1.672-.03-1.672Z"
      />
      <path
        fill="#F7A283"
        d="M28.342 11.916c0-1.372-1.108-2.271-2.476-2.271-1.369 0-2.477.898-2.477 2.271 0 0-.108 1.751-.108 1.837 0 1.304 1.597 2.959 2.585 2.959 1.14 0 2.585-1.971 2.585-2.96 0-.084-.109-1.836-.109-1.836ZM25.895 19.261c1.299 0 1.933-1.266 1.628-1.357-.86-.255-1.497-.41-1.497-.41s-.728.164-1.711.464c-.338.102.317 1.303 1.58 1.303Z"
      />
      <path
        fill="#F16431"
        d="M33.757 24.158c-.388-1.156-1.108-3.167-1.962-4.198-.515-.62-2.989-1.535-4.339-1.983-.262 1.23-2.89 1.233-3.19.053-1.19.423-3.567 1.35-4.374 2.036-1.807 1.536-2.308 5.326-2.415 5.869-.327 1.676-.938 5.21-.463 6.073.27.49.62 1.103 1.647 1.614l.642.128v3.335h14.723c.45-.348.794-4.173.798-5.077.009-1.752-.445-5.994-1.067-7.85Z"
      />
      <path
        fill="#D6D6D6"
        d="M9.512 28.931c4.854-2.855.625-14.418.625-14.418s-4.962-1.281-5.513.025c-2.062 4.89-6.03 12.332-4.721 15.023 2.571-1.206 8.232.18 9.609-.63Z"
      />
      <path
        fill="#D6D6D6"
        d="M4.562 17.02s-.335-1.853.259-2.998c.745-1.44 2.974-2.234 4.69-.701 1.195 1.067.567 3.883.567 3.883l-3.742-1.591-1.774 1.407Z"
      />
      <path
        fill="#F7A283"
        d="M8.762 22.768s-1.61.752-2.712-.078l.235-3.17h2.203l.274 3.248ZM5.03 16.695s-.316-.205-.56.121c-.245.326-.082 1.55.53 1.55.611 0 .03-1.672.03-1.672ZM9.76 16.695s.316-.205.561.121c.245.326.082 1.55-.53 1.55s-.031-1.672-.031-1.672Z"
      />
      <path
        fill="#F7A283"
        d="M9.863 16.355c0-1.373-1.109-2.271-2.477-2.271-1.368 0-2.477.898-2.477 2.27 0 0-.107 1.752-.107 1.837 0 1.304 1.597 2.96 2.585 2.96 1.14 0 2.584-1.972 2.584-2.96 0-.085-.108-1.836-.108-1.836ZM7.371 23.83c1.292 0 1.922-1.272 1.62-1.363a33.956 33.956 0 0 0-1.49-.41s-.723.163-1.7.464c-.336.103.315 1.309 1.57 1.309Z"
      />
      <path
        fill="#F16431"
        d="M16.357 36.551c.009-1.759-.445-6.017-1.067-7.88-.388-1.16-1.108-3.178-1.962-4.212-.514-.622-2.989-1.541-4.338-1.992-.262 1.236-2.891 1.238-3.19.054-1.19.424-3.567 1.355-4.374 2.044-1.807 1.54-2.308 5.345-2.414 5.89-.328 1.683-.939 5.229-.464 6.096.097.177.205.37.35.569h17.42c.024-.198.038-.391.04-.569Z"
      />
      <path
        fill="#323232"
        d="M16.216 15.613s-.334-1.852.259-2.997c.746-1.441 3.687-2.808 4.543-2.288.857.52-.584 1.331-.186 1.496.398.166.754-.761 1.008-.554 1.032.839-.108 4.527-.108 4.527l-3.742-1.59-1.774 1.407Z"
      />
      <path
        fill="#F7A283"
        d="m20.377 20.992-1.337 1.271-1.337-1.27.235-2.88h2.203l.236 2.88ZM16.685 15.288s-.317-.204-.561.121c-.245.327-.082 1.55.53 1.55s.03-1.671.03-1.671ZM21.414 15.288s.316-.204.561.121c.245.327.082 1.55-.53 1.55-.611 0-.03-1.671-.03-1.671Z"
      />
      <path
        fill="#F7A283"
        d="M21.516 14.947c0-1.372-1.108-2.27-2.476-2.27-1.369 0-2.477.898-2.477 2.27 0 0-.108 1.752-.108 1.837 0 1.304 1.597 2.96 2.585 2.96 1.14 0 2.585-1.972 2.585-2.96 0-.085-.108-1.836-.108-1.836ZM18.979 22.32c1.299 0 1.933-1.267 1.628-1.358-.86-.255-1.497-.41-1.497-.41s-.728.164-1.711.463c-.338.103.317 1.304 1.58 1.304Z"
      />
      <mask id="b" fill="#fff">
        <path d="M17.792 16.54a.965.965 0 0 1 0-1.926.965.965 0 0 1 0 1.927Zm0-1.831a.87.87 0 0 0 0 1.737.869.869 0 0 0 0-1.737Z" />
      </mask>
      <path
        fill="#282644"
        d="M17.792 16.54a.965.965 0 0 1 0-1.926.965.965 0 0 1 0 1.927Zm0-1.831a.87.87 0 0 0 0 1.737.869.869 0 0 0 0-1.737Z"
      />
      <path
        fill="#000"
        d="M17.792 15.54c.004 0 .01.002.015.004a.035.035 0 0 1 .01.007.033.033 0 0 1 .008.01.043.043 0 0 1 .003.016h-2c0 1.084.88 1.964 1.964 1.964v-2Zm.036.037c0 .004 0 .01-.003.016a.032.032 0 0 1-.007.01.033.033 0 0 1-.01.007.043.043 0 0 1-.016.004v-2c-1.084 0-1.964.88-1.964 1.963h2Zm-.036.037a.043.043 0 0 1-.016-.004.031.031 0 0 1-.018-.018.04.04 0 0 1-.003-.015h2c0-1.083-.88-1.963-1.963-1.963v2Zm-.037-.037a.04.04 0 0 1 .01-.026.035.035 0 0 1 .011-.007.041.041 0 0 1 .016-.003v2c1.082 0 1.963-.88 1.963-1.964h-2Zm.037-1.868a1.87 1.87 0 0 0-1.869 1.868h2a.13.13 0 0 1-.131.132v-2Zm-1.869 1.868a1.87 1.87 0 0 0 1.869 1.869v-2a.13.13 0 0 1 .131.131h-2Zm1.869 1.869a1.869 1.869 0 0 0 1.868-1.869h-2c0-.073.058-.131.132-.131v2Zm1.868-1.869a1.87 1.87 0 0 0-1.868-1.868v2a.13.13 0 0 1-.132-.132h2Z"
        mask="url(#b)"
      />
      <mask id="c" fill="#fff">
        <path d="M20.361 16.54a.965.965 0 0 1 0-1.926.964.964 0 0 1 0 1.927Zm0-1.831a.87.87 0 0 0 0 1.736.87.87 0 0 0 0-1.736Z" />
      </mask>
      <path
        fill="#282644"
        d="M20.361 16.54a.965.965 0 0 1 0-1.926.964.964 0 0 1 0 1.927Zm0-1.831a.87.87 0 0 0 0 1.736.87.87 0 0 0 0-1.736Z"
      />
      <path
        fill="#000"
        d="M20.361 15.54c.004 0 .01.002.015.004a.034.034 0 0 1 .011.007.042.042 0 0 1 .01.026h-2c0 1.084.88 1.964 1.964 1.964v-2Zm.037.037-.004.016a.031.031 0 0 1-.018.018.043.043 0 0 1-.015.003v-2c-1.084 0-1.963.88-1.963 1.963h2Zm-.037.037a.043.043 0 0 1-.015-.004.031.031 0 0 1-.018-.018.042.042 0 0 1-.004-.015h2c0-1.083-.879-1.963-1.963-1.963v2Zm-.037-.037c0-.004.001-.01.004-.015a.032.032 0 0 1 .007-.01.04.04 0 0 1 .026-.01v1.999c1.083 0 1.963-.88 1.963-1.964h-2Zm.037-1.868a1.87 1.87 0 0 0-1.868 1.868h2a.13.13 0 0 1-.132.132v-2Zm-1.868 1.868c0 1.032.837 1.868 1.868 1.868v-2c.073 0 .132.059.132.132h-2Zm1.868 1.868a1.87 1.87 0 0 0 1.869-1.868h-2a.13.13 0 0 1 .131-.132v2Zm1.869-1.868a1.87 1.87 0 0 0-1.869-1.868v2a.13.13 0 0 1-.131-.132h2Z"
        mask="url(#c)"
      />
      <mask id="d" fill="#fff">
        <path d="M19.397 15.417h-.642v.16h.642v-.16Z" />
      </mask>
      <path fill="#282644" d="M19.397 15.417h-.642v.16h.642v-.16Z" />
      <path
        fill="#000"
        d="M18.755 15.417v-1h-1v1h1Zm.642 0h1v-1h-1v1Zm0 .16v1h1v-1h-1Zm-.642 0h-1v1h1v-1Zm0 .84h.642v-2h-.642v2Zm-.358-1v.16h2v-.16h-2Zm1-.84h-.642v2h.642v-2Zm.358 1v-.16h-2v.16h2Z"
        mask="url(#d)"
      />
      <path
        fill="#D0F2FA"
        d="M28.069 34.95c.008-1.758-.446-6.014-1.068-7.875-.388-1.16-1.108-3.177-1.963-4.21-.514-.623-2.989-1.541-4.339-1.991-.262 1.235-2.892 1.237-3.19.053-1.191.425-3.569 1.355-4.377 2.043-1.807 1.54-2.308 5.343-2.415 5.887-.218 1.12-.662 4.153-.793 6.308h18.138c.004-.073.007-.145.007-.215Z"
      />
    </g>
  </Icon>
);

export default memo(StarredContactsZeroState6Icon);
